import { createHttpInstance } from "../http/httpFactory";

const billerHttp = createHttpInstance({
  baseURL: process.env.REACT_APP_BASE_URL, // || "https://localhost:7037",
  withCredentials: true,
  name: "biller",
  timeout: 15000,
  defaultHeaders: {
    // "Content-Type": "application/json",
  },
});

export default billerHttp;

const billerDetailsHttp = createHttpInstance({
  baseURL: process.env.REACT_APP_BASE_URL, // || "https://api.cashquin.com",
  withCredentials: true,
  name: "billerDetails",
  timeout: 15000,
  defaultHeaders: {
    "Content-Type": "application/json",
  },
});

export { billerDetailsHttp };

const razorpaypaymentHttp = createHttpInstance({
  baseURL: process.env.REACT_APP_BASE_URL, // || "https://api.cashquin.com",
  withCredentials: true,
  name: "razorpaypaymentHttp",
  timeout: 15000,
  defaultHeaders: {
    "Content-Type": "application/json",
  },
});

export { razorpaypaymentHttp };
